module.exports = __webpack_public_path__ + "img/slideshow.049dd7db.png";